import { cx } from "shared/utils";

/** Green "live" dot with a soft ping; the ping stops for reduced motion. */
export const LiveDot = ({ className }: { className?: string }) => (
  <span
    aria-hidden="true"
    className={cx("relative inline-flex h-2 w-2 shrink-0", className ?? "")}
  >
    <span className="absolute inline-flex h-full w-full rounded-full bg-success-500 opacity-75 motion-safe:animate-ping" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-success-500" />
  </span>
);
